import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { NAVGLOBAL_LINKS } from "../js/navigation/nav-global-items";
import NavLink from "./navigation/nav-link";
import Search from "./search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { StaticImage } from "gatsby-plugin-image";

const Header = ({ location }) => (
  <div className="container-global-header" id="totop">
    {/* Exec Order banner */}
    <div className="uk-alert-primary uk-margin-remove uk-padding-small" data-uk-alert>
      <p className="uk-margin-remove bolder uk-text-center uk-text-large">
        <strong>
          This repository is under review for potential modification in compliance with Administration directives.
        </strong>
      </p>
    </div>
    {/* branding */}
    <header>
      <div className="uk-container">
        <div className="uk-grid uk-grid-small uk-position-relative uk-margin-small-bottom" data-uk-grid="true">
          {/* mobile logo */}
          <div className="uk-width-1-1 uk-position-relative uk-text-center uk-hidden@m">
            <Link to="/" title="NACC home">
              <StaticImage
                src={"../images/nacc-logo.png"}
                alt="National Alzheimer's Coordinating Center"
                height={50}
                loading={"eager"}
              />
            </Link>
          </div>
          {/* desktop logo */}
          <div className="uk-width-1-6@m uk-width-1-1@s uk-position-relative uk-text-center uk-visible@m">
            <Link to="/" title="NACC home">
              <StaticImage
                src={"../images/nacc-logo.png"}
                alt="National Alzheimer's Coordinating Center"
                height={50}
                loading={"eager"}
                quality={100}
              />
            </Link>
          </div>
          <div className="uk-width-2-3@m uk-width-1-1@s">
            <div className="subtitle uk-text-left@m uk-text-center@s">
              The NIA Alzheimer&rsquo;s Disease Research Centers Program
            </div>
            <div className="title uk-text-left@m uk-text-center@s">National Alzheimer&rsquo;s Coordinating Center</div>
          </div>
          <div className="uk-width-1-6@m uk-width-1-1@s">
            <a
              href="https://www.alz.washington.edu/MEMBER/portal"
              className="login-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Legacy Portal
            </a>
          </div>
        </div>
      </div>
      <div className="uk-width-1-1">
        {/* desktop nav */}
        <div className="nav-global-desktop uk-visible@m uk-box-shadow-small">
          <div className="uk-container container-global-header">
            <div className="uk-grid-collapse" data-uk-grid="true">
              <div className="uk-width-1-6" />
              {/* navigation */}
              <div className="uk-width-2-3">
                <nav
                  className="uk-navbar-container uk-navbar-transparent"
                  data-uk-navbar="mode: hover,click"
                  role="navigation"
                  aria-label="Primary"
                >
                  <ul className="uk-navbar-nav uk-width-1-1" data-uk-navbar="true">
                    {NAVGLOBAL_LINKS.map((element, index) => (
                      <li className="uk-width-auto" key={index}>
                        <button
                          className={
                            element.class + (location && location.pathname.startsWith(element.slug) ? " uk-active" : "")
                          }
                          tabIndex="0"
                        >
                          {element.title}
                        </button>
                        <div className="uk-navbar-dropdown">
                          <ul className="uk-nav uk-navbar-dropdown-nav">
                            {element.children &&
                              element.children.map((child, j) => (
                                <li key={j}>
                                  <NavLink url={child.url} className={child.class} title={child.title} />
                                </li>
                              ))}
                          </ul>
                        </div>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
              {/* search dropdown */}
              <div className="uk-width-1-6 search-column">
                <div className="uk-inline">
                  <Search />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* mobile nav */}
        <button
          type="button"
          aria-label="mobile menu"
          className="uk-hidden@m uk-button uk-width-1-1 uk-text-left"
          style={{ color: "white", background: "#003f7f" }}
          data-uk-toggle="target: #mobileNav"
        >
          <FontAwesomeIcon
            icon={faBars}
            size="2x"
            className="uk-margin-remove-bottom uk-margin-small-right"
            style={{ color: "#fff", fontSize: "1.25em" }}
          />
          <span className="uk-text-uppercase" style={{ fontSize: "1em" }}>
            Menu
          </span>
        </button>
        <div id="mobileNav" className="nav-global-mobile" data-uk-offcanvas="slide: true">
          <div className="uk-offcanvas-bar" data-uk-navbar="mode: click">
            <button className="uk-offcanvas-close" aria-label="close" type="button" data-uk-close="true" />
            <ul className="uk-nav-default uk-nav-parent-icon" data-uk-nav="true">
              {NAVGLOBAL_LINKS.map((element, index) => (
                <li className="uk-parent" key={index}>
                  <Link to={element.url} title={element.title} target={element.target} className={element.class}>
                    {element.title}
                  </Link>
                  <ul className="uk-nav-sub">
                    {element.children &&
                      element.children.map((child, j) => (
                        <li key={j}>
                          <NavLink url={child.url} className={child.class} title={child.title} />
                        </li>
                      ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="uk-hidden@m">
          <Search />
        </div>
      </div>
    </header>
  </div>
);

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: `site title`,
};

export default Header;
